/**
 * Vite entry point for unity/base admin dashboard.
 * Migration: Next.js → Vite 6 + React Router v7 (ADR-006, ADR-020, E32 T-3900)
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import './lib/sentry'
import './styles/tailwind.css'
import { router } from './router'

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found in index.html')

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
